<template>
  <div class="form">
    <van-form @submit="onSubmit">
      <van-field
        v-model="loginForm.username"
        placeholder="请输入用户名"
        :rules="[{ required: true, message: '请输入用户名' }]"
      />
      <van-field
        v-model="loginForm.password"
        type="password"
        placeholder="请输入密码"
        :rules="[{ required: true, message: '请输入密码' }]"
      />
      <van-field
        v-model="loginForm.validCode"
        center
        clearable
        placeholder="请输入验证码"
        :rules="[{ required: true, message: '请输入验证码' }]"
      >
        <template #button>
          <img :src="imgSrc" @click="newImg()" />
        </template>
      </van-field>
      <div class="ibtn">
        <van-button round block type="info" native-type="submit"
          >登录</van-button
        >
      </div>
    </van-form>
  </div>
</template>

<script>
export default {
  /* eslint-disable */
  data() {
    return {
      loginForm: {
        username: "",
        password: "",
        validCode: "",
        deviceId: "",
        client_id: "webApp",
        client_secret: "webApp",
        grant_type: "password",
        scoped: "app",
      },
      imgSrc: "",
    };
  },
  mounted() {
    // Private array of chars to use
    var CHARS =
      "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split(
        ""
      );
    Math.uuid = function (len, radix) {
      var chars = CHARS,
        uuid = [],
        i;
      radix = radix || chars.length;
      if (len) {
        // Compact form
        for (i = 0; i < len; i++) uuid[i] = chars[0 | (Math.random() * radix)];
      } else {
        // rfc4122, version 4 form
        var r;

        // rfc4122 requires these characters
        uuid[8] = uuid[13] = uuid[18] = uuid[23] = "-";
        uuid[14] = "4";

        // Fill in random data.  At i==19 set the high bits of clock sequence as
        // per rfc4122, sec. 4.1.5
        for (i = 0; i < 36; i++) {
          if (!uuid[i]) {
            r = 0 | (Math.random() * 16);
            uuid[i] = chars[i == 19 ? (r & 0x3) | 0x8 : r];
          }
        }
      }
      return uuid.join("");
    };
    // 生成的uuid码
    this.loginForm.deviceId = Math.uuid();
    this.imgSrc =
      this.$common.urlFName +
      "api-auth/validata/code/" +
      this.loginForm.deviceId;
    // this.newImg(uuid)
  },
  methods: {
    newImg() {
      // alert('1')
      this.loginForm.validCode = "";
      // 每次点击获取一次时间戳
      this.imgSrc = this.imgSrc + "?" + "timestamp=" + Date.parse(new Date());
    },
    onSubmit() {
      let that = this;
      let formData = new FormData();
      formData.append("username", that.loginForm.username);
      formData.append("password", that.loginForm.password);
      formData.append("validCode", that.loginForm.validCode);
      formData.append("deviceId", that.loginForm.deviceId);
      formData.append("client_id", that.loginForm.client_id);
      formData.append("client_secret", that.loginForm.client_secret);
      formData.append("grant_type", that.loginForm.grant_type);
      formData.append("scoped", that.loginForm.scoped);
      that.post("api-auth/oauth/token", formData).then((res) => {
        console.log(res.access_token);
        that.$router.push({
          path: "/population",
          query: {
            token: "Bearer " + res.access_token,
          },
        });
      });
    },
  },
};
</script>

<style scoped>
.form {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
}
.van-form {
  width: 90%;

  box-shadow: 0px 0px 10px 0px rgba(43, 133, 228, 0.15);
}
.van-cell {
  margin: 20px 0;
}
.van-cell--center {
  padding-top: 0;
  padding-bottom: 0;
}
img {
  width: 100px;
}
.ibtn{
  margin: 0 15px 15px;
}
</style>
